import { apiSlice } from "./apiSlice";

export const getApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createContactUs: builder.mutation({
      query: (contactUsData) => ({
        url: "/contactUs/createContactUs",
        method: "POST",
        body: contactUsData,
      }),
    }),

    getActiveBanners: builder.query({
      query: () => ({
        url: "/banners/getActiveBanners",
        method: "GET",
      }),
    }),
    getAllPopUpPublic: builder.query({
      query: () => ({
        url: "/popUps/getAllPopUpPublic",
        method: "GET",
      }),
    }),
    getAllCareers: builder.query({
      query: () => ({
        url: "/careers/getAllCareersPublic",
        method: "GET",
      }),
    }),
    getAllAnnouncements: builder.query({
      query: () => ({
        url: "/announcements/getAllAnnouncements",
        method: "GET",
      }),
    }),
    getPublishedBlogs: builder.query({
      query: () => ({
        url: "/blogs/getPublishedBlogs",
        method: "GET",
      }),
    }),
    getLatestPublishedBlogs: builder.query({
      query: () => ({
        url: "/blogs/getLatestPublishedBlogs",
        method: "GET",
      }),
    }),
    getBlogById: builder.query({
      query: (id) => ({
        url: `/blogs/getPublishedBlogById/${id}`,
        method: "GET",
      }),
    }),
    getProjectById: builder.query({
      query: (id) => ({
        url: `/projects/getProjectByIdPublic/${id}`,
        method: "GET",
      }),
    }),
    // getAllDownloads: builder.query({
    //   query: () => ({
    //     url: "/downloads/getAllDownloadsPublic",
    //     method: "GET",
    //   }),
    // }),

    getAllDownloads: builder.query({
      query: (directorates) => {
        const params = new URLSearchParams();
        if (directorates) {
          params.append("directorates", directorates);
        }

        return {
          url: `/downloads/getAllDownloadsPublic?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getAllMedia: builder.query({
      query: () => ({
        url: "/media/getAllMedia",
        method: "GET",
      }),
    }),
    getAllPressReleases: builder.query({
      query: () => ({
        url: "/pressReleases/getAllPressReleasesPublic",
        method: "GET",
      }),
    }),
    getAllProjects: builder.query({
      query: () => ({
        url: "/projects/getAllProjectsPublic",
        method: "GET",
      }),
    }),
    getAllPublicNotices: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        return {
          url: `/publicNotices/getAllPublicNotices?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    getApprovedSocieties: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/societies/approved?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getUnapprovedSocieties: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/societies/unapproved?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getIllegalSocieties: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/societies/illegal?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getAllTenders: builder.query({
      query: () => ({
        url: "/tenders/getAllTendersPublic",
        method: "GET",
      }),
    }),
    getAllProfilesPublic: builder.query({
      query: () => ({
        url: "/managementProfiles/getAllProfilesPublic",
        method: "GET",
      }),
    }),
    getAllPublicGeneralDirector: builder.query({
      query: () => ({
        url: "/managementProfiles/getAllPublicGeneralDirector",
        method: "GET",
      }),
    }),
    getAllLatestNewsPublic: builder.query({
      query: () => ({
        url: "/latestNews/getAllLatestNewsPublic",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetActiveBannersQuery,
  useGetAllAnnouncementsQuery,
  useGetAllCareersQuery,
  useGetAllDownloadsQuery,
  useGetAllMediaQuery,
  useGetAllPressReleasesQuery,
  useGetAllProjectsQuery,
  useGetAllPublicNoticesQuery,
  useGetAllTendersQuery,
  useGetPublishedBlogsQuery,
  useCreateContactUsMutation,
  useGetApprovedSocietiesQuery,
  useGetUnapprovedSocietiesQuery,
  useGetIllegalSocietiesQuery,
  useGetAllPopUpPublicQuery,
  useGetAllProfilesPublicQuery,
  useGetAllPublicGeneralDirectorQuery,
  useGetLatestPublishedBlogsQuery,
  useGetBlogByIdQuery,
  useGetProjectByIdQuery,
  useGetAllLatestNewsPublicQuery,
} = getApi;
